import { Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';

export const version = environment.apiVersion;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public isLoggedIn = false;
  public loginState: string;
  public redirectUrl: string;
  public connecting = false;
  public isDisconnected: boolean;
  public $token = signal<string | null>(null);

  public login() {
    this.isLoggedIn = true;
    this.connecting = true; // not sure about this variable in this method
    this.isDisconnected = false;
  }

  public logout() {
    this.isLoggedIn = false;
    this.connecting = false;
    this.isDisconnected = true;
    this.loginState = undefined;
  }

  public noRedirect() {
    this.redirectUrl = undefined;
  }

  public setLoginState(state: string) {
    this.loginState = state;
  }

  public getLoginState(): string {
    return this.loginState;
  }

  public getStoredToken(): string {
    return localStorage?.getItem('token');
  }
}
